const filterProps = (props, filteredKeys) =>
  Object.keys(props)
    .filter((key) => !filteredKeys.includes(key))
    .reduce((acc, key) => {
      acc[key] = props[key]
      return acc
    }, {})

export default filterProps
